<template>
<div class="form-group" ref="dropdownMenu">
  <ValidationProvider tag="div"
                          class="form-field field-select"
                          :class="activeField"
                          :rules="rules"
                          :immediate="!!value"
                          >
        <div class="custom-select" @blur="open = false">
        <input class="form-control selected" :class="{ open: open }"  type="text" @keydown.enter.stop.prevent v-model="selected" @click="dropdownClick()" @keyup.up="focusPrevOption(0)" @keyup.down="focusNextOption(options.length - 1)" @keydown.space.prevent="dropdownClick()" readonly>
        <label class="select-label" @click="dropdownClick()">{{ title }}</label>
        <label class="select-input" @click="dropdownClick()">{{ $t('checkResult:form.labels.dropdownMenu.defaultValue') }}</label>
        <span class="custom-dropdown">
            <span class="arrow is-triangle" :class="iconToporDown" @click="dropdownClick()"></span>
        </span>
        <div class="items" :class="{ scrollbar, selectHide: !open }">
          <div
            :ref="'option' + i"
            tabindex="0"
            v-for="(option, i) of options"
            :key="i"
            @click="selectOption(option)"
            @keyup.up="focusPrevOption(i)"
            @keyup.down="focusNextOption(i)"
            @keydown.space.prevent="selectOption(option)"
            >
            {{ $t(option.label) }}
          </div>
        </div>
      </div>
  </ValidationProvider>
</div>
</template>

<script>
import BaseField from './BaseField'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'SelectCustom',
    extends: BaseField,
    components: {
        SvgIcon
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        default: {
            type: String,
            required: false,
            default: null
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            selected: this.default ? this.default : '',
            open: false,
            activeField: false,
            iconToporDown: 'is-bottom',
            scrollbar: ''
        }
    },
    methods: {
        focusPrevOption(index) {
            if (index === 0) {
                index = (this.options.length - 1)
            } else {
                index--
            }
            this.$refs['option' + index][0].focus()
        },
        focusNextOption(index) {
            if (index === (this.options.length - 1)) {
                index = 0
            } else {
                index++
            }
            this.$refs['option' + index][0].focus()
        },
        dropdownClick() {
            this.open = !this.open
            this.iconToporDown = this.open ? 'is-top' : 'is-bottom'
            this.$refs['option0'][0].focus()
        },
        documentClick(e) {
            let el = this.$refs.dropdownMenu
            let target = e.target
            if (el && (el !== target) && !el.contains(target)) {
                this.open = false
                this.iconToporDown = 'is-bottom'
            }
        },
        selectOption(option) {
            this.selected = this.$i18n.t(option.value)
            this.open = false
            this.iconToporDown = 'is-bottom'
            this.activeField = 'active'
            this.$emit('input', this.$i18n.t(option.value))
        }
    },
    created() {
        document.addEventListener('click', this.documentClick)
    },
    mounted() {
        this.$emit('input', this.selected)
        this.scrollbar = this.options.length > 6 ? 'scrollbar' : ''
    }
}
</script>
